// @ts-nocheck
/* eslint-disable */
export const appChevronLeftV240Icon = {
    data: `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26.5 9L14 20.2168L26.5 31.4337" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
    name: 'chevron-left-v-2-40' as const
};